export default function apiURL() {
  const api = process.env.NODE_ENV === 'development' ? 'localhost:7226' : 'api.slicoinsurance.com';
  const baseURL = `https://${api}/api/`
  return baseURL
}